module.exports = __webpack_public_path__ + "img/Speedo.9153a79d.png";